function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5971 7.702C10.4837 7.476 10.2531 7.33334 10.0004 7.33334H8.66709V0.666656C8.66709 0.298656 8.36909 0 8.00043 0C7.63178 0 7.33378 0.298656 7.33378 0.666656V7.33331H6.00043C5.74778 7.33331 5.51709 7.47597 5.40378 7.70197C5.29178 7.92797 5.31578 8.19797 5.46712 8.39997L7.46712 11.0666C7.47578 11.078 7.48912 11.082 7.49846 11.0926C7.54246 11.1446 7.59447 11.1846 7.65247 11.2213C7.67647 11.2359 7.69512 11.2553 7.72112 11.2673C7.80646 11.3073 7.89978 11.3333 8.00047 11.3333C8.10115 11.3333 8.19446 11.3073 8.28046 11.2673C8.30581 11.2553 8.32512 11.2359 8.34846 11.2213C8.40646 11.1846 8.45847 11.1446 8.50247 11.0926C8.51112 11.082 8.52512 11.078 8.53381 11.0666L10.5338 8.39997C10.6858 8.198 10.7098 7.928 10.5971 7.702Z",
  fill: "#D18F1F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3333 10C14.9647 10 14.6667 10.2987 14.6667 10.6667V12.6667C14.6667 13.7693 13.7693 14.6667 12.6667 14.6667H3.33334C2.23069 14.6667 1.33334 13.7693 1.33334 12.6667V10.6667C1.33334 10.2987 1.03534 10 0.666687 10C0.298 10 0 10.2987 0 10.6667V12.6667C0 14.5047 1.49534 16 3.33334 16H12.6667C14.5047 16 16 14.5047 16 12.6667V10.6667C16 10.2987 15.702 10 15.3333 10Z",
  fill: "#D18F1F"
});
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3dad2fa29ced19c53985bcc9ae33596e.svg";
export { ForwardRef as ReactComponent };